import axios from 'axios';
import { API_URL } from '../constantes/constantes';

export async function getSearch(query, page, PAGESIZE, category, token) {
    const BASE_PATH = API_URL;
    let encodeQuery =  encodeURI(query);
    let apiURL = `${BASE_PATH}search_content?q=${encodeQuery}&from=${page * PAGESIZE}&size=${PAGESIZE}&category=${category}&utm_campaign=buscador`;

    const config = {
        method: 'get',
        url: apiURL,
        timeout: 25000,
        withCredentials: false,
        headers: {
            'Accept': 'application/json, text/plain, */*',
            'Content-Type': 'application/json; charset=utf-8',
            'Authorization': `Bearer ${token}`
        }
    }

    try {
        const response = await axios(config);
        if (response.status === 200) {
            return { data: response.data, statusCode: 200 };
        } else if (response.status === 404) {
            // Recurso no encontrado
            return { statusCode: 404, data: [] };
        } else if (response.status === 401) {
            // Recurso no encontrado
            return { statusCode: 401, data: [] };
        } else {
            // Otro código de estado, manejar según sea necesario
            return { statusCode: response.status, data: [] };
        }
    } catch (error) {
        // Manejar errores de la petición
        // console.error("Error en la petición:", error);
        return { statusCode: 401, data: [] };
    }
}